module.exports = __webpack_public_path__ + "static/media/image_broken_error.4c5768a4.png";